import React from 'react'
import Footer from './include/Footer'
import Header from './include/Header'
import { Link } from 'react-router-dom'

function Home() {
    return (
        <>
        
           <Header/>

            <div className="hero bg-section">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="hero-box">

                                <div className="hero-content">

                                    <div className="section-title">
                                        <h3 className="wow fadeInUp">AI That Thinks Ahead</h3>
                                        <h1 className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">Next-generation AI solutions for <span>modern business</span></h1>
                                        <p className="wow fadeInUp" data-wow-delay="0.4s">From intelligent automation to predictive insights, we deliver powerful AI solutions built for real-world performance, scalability, and results, Discover how our technology is changing.</p>
                                    </div>

                                    <div className="hero-btn wow fadeInUp" data-wow-delay="0.6s">
                                        <Link to="contact.html" className="btn-default">Get Started</Link>
                                        <Link to="contact.html" className="btn-default btn-highlighted">View Solutions</Link>
                                    </div>

                                </div>

                                <div className="hero-image-box flowmap-effect">
                                    <div className="flowmap-deformation" data-bg="/assets/images/hero-image.jpg" data-bg-width="1600" data-bg-height="1015"
                                        style={{
                                            backgroundImage: "url(/assets/images/hero-image.jpg)",
                                            backgroundSize: "cover",
                                            backgroundPosition: "center",
                                            height: "100vh"
                                        }}
                                    ></div>


                                    <div className="video-play-button">
                                        <Link to="https://www.youtube.com/watch?v=Y-x0efG1seA" className="popup-video" data-cursor-text="Play">
                                            <i className="fa-solid fa-play"></i>
                                        </Link>
                                        <h3>Watch Video</h3>
                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className="col-lg-4">

                            <div className="hero-info-item hero-info-box-1 wow fadeInUp">

                                <div className="hero-info-content">
                                    <h3>AI That Grows With You</h3>
                                    <p>Whether you're just starting or scaling globally, our adaptive AI platform evolves with your business.</p>
                                </div>

                                <div className="hero-info-body">

                                    <div className="hero-info-body-content">
                                        <ul>
                                            <li>Customizable Architecture.</li>
                                            <li>Learns from Your Unique Data.</li>
                                        </ul>
                                        <Link to="contact.html" className="btn-default">Learn More</Link>
                                    </div>

                                    <div className="hero-info-image">
                                        <figure>
                                            <img src="/assets/images/hero-info-image-1.png" alt="" />
                                        </figure>
                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className="col-lg-4">

                            <div className="hero-info-item hero-info-box-2 wow fadeInUp" data-wow-delay="0.2s">
                                <div className="icon-box hero-icon-box-1">
                                    <img src="/assets/images/icon-hero-info-1.svg" alt="" />
                                </div>
                                <div className="icon-box hero-icon-box-2">
                                    <img src="/assets/images/icon-hero-info-2.svg" alt="" />
                                </div>
                                <div className="hero-info-content">
                                    <h2>Your All-In-One <span>AI Powerhouse</span></h2>
                                    <p>A complete, intelligent platform designed to automate tasks</p>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-4">

                            <div className="hero-info-item hero-info-box-3 wow fadeInUp" data-wow-delay="0.4s">

                                <div className="hero-info-content">
                                    <h3>AI That Grows With You</h3>
                                    <p>Whether you're just starting or scaling globally, our adaptive AI platform evolves with your business.</p>
                                </div>

                                <div className="hero-info-body">

                                    <div className="review-box">

                                        <div className="review-images">
                                            <div className="review-image">
                                                <figure className="image-anime">
                                                    <img src="/assets/images/author-1.jpg" alt="" />
                                                </figure>
                                            </div>
                                            <div className="review-image">
                                                <figure className="image-anime">
                                                    <img src="/assets/images/author-2.jpg" alt="" />
                                                </figure>
                                            </div>
                                            <div className="review-image">
                                                <figure className="image-anime">
                                                    <img src="/assets/images/author-3.jpg" alt="" />
                                                </figure>
                                            </div>
                                            <div className="review-image">
                                                <figure className="image-anime">
                                                    <img src="/assets/images/author-4.jpg" alt="" />
                                                </figure>
                                            </div>
                                            <div className="review-image add-more">
                                                <h3><span className="counter">15</span>k+</h3>
                                            </div>
                                        </div>

                                        <div className="satisfy-client-content">
                                            <h3><span>98%</span> Client Retention Rate</h3>
                                        </div>

                                    </div>

                                    <div className="hero-info-image">
                                        <figure>
                                            <img src="/assets/images/hero-info-image-2.png" alt="" />
                                        </figure>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="about-us">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">

                            <div className="about-image-box">

                                <div className="about-us-image">
                                    <figure className="image-anime">
                                        <img src="/assets/images/about-us-image.jpg" alt="" />
                                    </figure>
                                </div>

                                <div className="contact-us-circle">
                                    <Link to="contact.html">
                                        <img src="/assets/images/contact-us-circle.svg" alt="" />
                                    </Link>
                                </div>

                                <div className="about-review">

                                    <div className="about-review-box">

                                        <div className="review-images">
                                            <div className="review-image">
                                                <figure className="image-anime">
                                                    <img src="/assets/images/author-1.jpg" alt="" />
                                                </figure>
                                            </div>
                                            <div className="review-image">
                                                <figure className="image-anime">
                                                    <img src="/assets/images/author-2.jpg" alt="" />
                                                </figure>
                                            </div>
                                            <div className="review-image">
                                                <figure className="image-anime">
                                                    <img src="/assets/images/author-3.jpg" alt="" />
                                                </figure>
                                            </div>
                                            <div className="review-image">
                                                <figure className="image-anime">
                                                    <img src="/assets/images/author-4.jpg" alt="" />
                                                </figure>
                                            </div>
                                        </div>

                                        <div className="review-info-content">
                                            <div className="review-rating">
                                                <i className="fa fa-solid fa-star"></i>
                                                <i className="fa fa-solid fa-star"></i>
                                                <i className="fa fa-solid fa-star"></i>
                                                <i className="fa fa-solid fa-star"></i>
                                                <i className="fa fa-solid fa-star"></i>
                                            </div>
                                            <div className="review-content">
                                                <p>3,500 Reviews (<span className="counter">4.9</span>)</p>
                                            </div>
                                        </div>

                                        <div className="video-play-button bg-effect">
                                            <Link to="https://www.youtube.com/watch?v=Y-x0efG1seA" className="popup-video" data-cursor-text="Play">
                                                <i className="fa-solid fa-play"></i>
                                            </Link>
                                            <h3>Our Video</h3>
                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>

                        <div className="col-lg-7">

                            <div className="about-us-content">

                                <div className="section-title">
                                    <h3 className="wow fadeInUp">About Us</h3>
                                    <h2 className="wow fadeInUp text-effect" data-wow-delay="0.2s" data-cursor="-opaque">Reimagining the future through AI that Is transparent, impact and built to empower people, not replace them</h2>
                                </div>

                                <div className="about-body-list wow fadeInUp" data-wow-delay="0.4s">

                                    <div className="about-body-item">
                                        <div className="about-body-header">
                                            <div className="icon-box">
                                                <img src="/assets/images/icon-about-body-1.svg" alt="" />
                                            </div>
                                            <div className="about-body-title">
                                                <h3>Tailored AI Solutions</h3>
                                            </div>
                                        </div>
                                        <div className="about-body-content">
                                            <p>That's why we develop custom AI systems that are aligned with your challenges.</p>
                                        </div>
                                    </div>

                                    <div className="about-body-item">
                                        <div className="about-body-header">
                                            <div className="icon-box">
                                                <img src="/assets/images/icon-about-body-2.svg" alt="" />
                                            </div>
                                            <div className="about-body-title">
                                                <h3>End-to-End Partnership</h3>
                                            </div>
                                        </div>
                                        <div className="about-body-content">
                                            <p>From initial consultation to post-launch support, we work as an extension.</p>
                                        </div>
                                    </div>

                                </div>

                                <div className="about-body-list-box wow fadeInUp" data-wow-delay="0.6s">
                                    <ul>
                                        <li>Solutions Tailored to Your Business.</li>
                                        <li>AI Expertise Backed by Real-World.</li>
                                        <li>Cutting-edge technology at the core.</li>
                                        <li>Built Around Your Business, Not Ours.</li>
                                    </ul>
                                </div>

                                <div className="about-us-button wow fadeInUp" data-wow-delay="0.8s">
                                    <Link to="about.html" className="btn-default">more about us</Link>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="our-services">
                <div className="container">
                    <div className="row section-row">
                        <div className="col-lg-12">

                            <div className="section-title section-title-center">
                                <h3 className="wow fadeInUp">Our Services</h3>
                                <h2 className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">AI-powered services that drive <span>business forward</span></h2>
                            </div>

                        </div>
                    </div>

                    <div className="row">
                      {/*   <div className="col-lg-4 col-md-6">
                            <div className="service-item wow fadeInUp">

                                <div className="service-content-box">
                                    <div className="service-item-header">
                                        <div className="service-item-title">
                                            <h3><Link to="service-single.html">AI Model Development</Link></h3>
                                        </div>
                                        <div className="icon-box">
                                            <Link to="service-single.html"><img src="/assets/images/arrow-white.svg" alt="" /></Link>
                                        </div>
                                    </div>
                                    <div className="service-item-content">
                                        <p>Have a unique problem? We'll design and train a custom machine learning.</p>
                                    </div>
                                </div>

                                <div className="service-item-image">
                                    <Link to="service-single.html" data-cursor-text="View">
                                        <figure className="image-anime">
                                            <img src="/assets/images/service-1.jpg" alt="" />
                                        </figure>
                                    </Link>
                                </div>

                            </div>
                        </div> */}

                        <div className="col-lg-4 col-md-6">
                            <div className="service-item wow fadeInUp" data-wow-delay="0.2s">
                                <div className="service-content-box">
                                    <div className="service-item-header">
                                        <div className="service-item-title">
                                            <h3><Link to="service-single.html">AI-Powered Chatbots</Link></h3>
                                        </div>
                                        <div className="icon-box">
                                            <Link to="service-single.html"><img src="/assets/images/arrow-white.svg" alt="" /></Link>
                                        </div>
                                    </div>
                                    <div className="service-item-content">
                                        <p>Deliver 24/7 support and personalized customer interactions.</p>
                                    </div>
                                </div>

                                <div className="service-item-image">
                                    <Link to="service-single.html" data-cursor-text="View">
                                        <figure className="image-anime">
                                            <img src="/assets/images/service-2.jpg" alt="" />
                                        </figure>
                                    </Link>
                                </div>

                            </div>

                        </div>

                        <div className="col-lg-4 col-md-6">

                            <div className="service-item wow fadeInUp" data-wow-delay="0.4s">

                                <div className="service-content-box">
                                    <div className="service-item-header">
                                        <div className="service-item-title">
                                            <h3><Link to="service-single.html">Predictive Analytics</Link></h3>
                                        </div>
                                        <div className="icon-box">
                                            <Link to="service-single.html"><img src="/assets/images/arrow-white.svg" alt="" /></Link>
                                        </div>
                                    </div>
                                    <div className="service-item-content">
                                        <p>Gain deeper insights into customer behavior, market trends.</p>
                                    </div>
                                </div>

                                <div className="service-item-image">
                                    <Link to="service-single.html" data-cursor-text="View">
                                        <figure className="image-anime">
                                            <img src="/assets/images/service-3.jpg" alt="" />
                                        </figure>
                                    </Link>
                                </div>

                            </div>

                        </div>

                        <div className="col-lg-12">

                            <div className="section-footer-text wow fadeInUp" data-wow-delay="0.6s">
                                <p><span>Free</span> Let's make something great work together. <Link to="contact.html">Get Free Quote</Link></p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="why-choose-us">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">

                            <div className="why-choose-info-box">

                                <div className="section-title">
                                    <h3 className="wow fadeInUp">Why choose us</h3>
                                    <h2 className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">AI that's built around your <span>business goals</span></h2>
                                </div>

                                <div className="why-choose-btn wow fadeInUp" data-wow-delay="0.4s">
                                    <Link  to="/contact" className="btn-default">Contact Us Today</Link>
                                </div>

                            </div>

                        </div>

                        <div className="col-lg-6">

                            <div className="why-choose-item why-choose-box-1">

                                <div className="why-choose-content">
                                    <h3>AI Development Cycle</h3>
                                    <p>Our streamlined workflow reduces time-to-market by combining agile methods with pre-trained models, automation, and modular components.</p>
                                </div>

                                <div className="why-choose-list">

                                    <div className="scrolling-ticker-item">
                                        <div className="scrolling-content">
                                            <span>ConversationalAI</span>
                                            <span>TextAnalysis</span>
                                            <span>Chatbots</span>
                                            <span>MultilingualAI</span>
                                            <span>Satisfaction</span>
                                        </div>

                                        <div className="scrolling-content">
                                            <span>ConversationalAI</span>
                                            <span>TextAnalysis</span>
                                            <span>Chatbots</span>
                                            <span>MultilingualAI</span>
                                            <span>Satisfaction</span>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className="col-lg-12">

                            <div className="why-choose-item-list">

                                <div className="why-choose-item why-choose-box-2">
                                    <div className="why-choose-item-header">
                                        <div className="why-choose-title-box">
                                            <div className="icon-box">
                                                <img src="/assets/images/icon-why-choose-1.svg" alt="" />
                                            </div>
                                            <div className="why-choose-content">
                                                <h3>End-to-End Support</h3>
                                            </div>
                                        </div>
                                        <div className="contact-us-circle">
                                            <Link to="contact.html">
                                                <img src="/assets/images/contact-us-circle.svg" alt="" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="why-choose-content">
                                        <p>From consultation to deployment and beyond - we partner with you at every stage.</p>
                                    </div>
                                    <div className="why-choose-btn">
                                        <Link to="contact.html" className="readmore-btn">read more</Link>
                                    </div>
                                </div>

                                <div className="why-choose-item why-choose-counter-box-1">
                                    <div className="why-choose-counter">
                                        <h2><span className="counter">98</span>%</h2>
                                    </div>
                                    <div className="why-choose-content">
                                        <h3>Client Satisfaction Rate</h3>
                                        <p>We consistently deliver solutions that meet expectations.</p>
                                    </div>
                                    <div className="why-choose-icon">
                                        <img src="/assets/images/icon-why-choose-counter-1.svg" alt="" />
                                    </div>
                                </div>

                                <div className="why-choose-item why-choose-counter-box-1">
                                    <div className="why-choose-counter">
                                        <h2><span className="counter">5</span>+</h2>
                                    </div>
                                    <div className="why-choose-content">
                                        <h3>AI Projects Delivered</h3>
                                        <p>Successfully deployed across industries worldwide.</p>
                                    </div>
                                    <div className="why-choose-icon">
                                        <img src="/assets/images/icon-why-choose-counter-2.svg" alt="" />
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                    <div className="col-lg-12">

                        <div className="section-footer-text wow fadeInUp" data-wow-delay="0.4s">
                            <p>We turn complexity into clarity with real-world AI - <Link to="contact.html">from data to decisions</Link></p>
                        </div>

                    </div>
                </div>
            </div>

         {/*    <div className="our-projects">
                <div className="container-fluid">
                    <div className="row section-row">
                        <div className="col-lg-12">

                            <div className="section-title section-title-center">
                                <h3 className="wow fadeInUp">Our project</h3>
                                <h2 className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">Solving complex problems with <span>smart scalable AI</span></h2>
                            </div>

                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-3 col-md-6">

                            <div className="project-item wow fadeInUp">
                                <div className="project-image">
                                    <Link to="project-single.html" data-cursor-text="View">
                                        <figure className="image-anime">
                                            <img src="/assets/images/project-1.jpg" alt="" />
                                        </figure>
                                    </Link>
                                </div>
                                <div className="project-content">
                                    <h3><Link to="project-single.html">VoxIQ Voice Analytics Tool</Link></h3>
                                    <p>Voice AI</p>
                                </div>
                                <div className="project-btn">
                                    <Link to="project-single.html">
                                        <img src="/assets/images/arrow-white.svg" alt="" />
                                    </Link>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-3 col-md-6">

                            <div className="project-item wow fadeInUp" data-wow-delay="0.2s">
                                <div className="project-image">
                                    <Link to="project-single.html" data-cursor-text="View">
                                        <figure className="image-anime">
                                            <img src="/assets/images/project-2.jpg" alt="" />
                                        </figure>
                                    </Link>
                                </div>
                                <div className="project-content">
                                    <h3><Link to="project-single.html">InsightEdge Sales Predictor</Link></h3>
                                    <p>Data Science</p>
                                </div>
                                <div className="project-btn">
                                    <Link to="project-single.html">
                                        <img src="/assets/images/arrow-white.svg" alt="" />
                                    </Link>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-3 col-md-6">

                            <div className="project-item wow fadeInUp" data-wow-delay="0.4s">
                                <div className="project-image">
                                    <Link to="project-single.html" data-cursor-text="View">
                                        <figure className="image-anime">
                                            <img src="/assets/images/project-3.jpg" alt="" />
                                        </figure>
                                    </Link>
                                </div>
                                <div className="project-content">
                                    <h3><Link to="project-single.html">AutoBot Smart Chat Assistant</Link></h3>
                                    <p>Conversational AI</p>
                                </div>
                                <div className="project-btn">
                                    <Link to="project-single.html">
                                        <img src="/assets/images/arrow-white.svg" alt="" />
                                    </Link>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-3 col-md-6">

                            <div className="project-item wow fadeInUp" data-wow-delay="0.6s">
                                <div className="project-image">
                                    <Link to="project-single.html" data-cursor-text="View">
                                        <figure className="image-anime">
                                            <img src="/assets/images/project-4.jpg" alt="" />
                                        </figure>
                                    </Link>
                                </div>
                                <div className="project-content">
                                    <h3><Link to="project-single.html">DocuSort Legal Doc classNameifier</Link></h3>
                                    <p>Automation</p>
                                </div>
                                <div className="project-btn">
                                    <Link to="project-single.html">
                                        <img src="/assets/images/arrow-white.svg" alt="" />
                                    </Link>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
 */}
            <div className="what-we-do">
                <div className="container">
                    <div className="row section-row">
                        <div className="col-lg-12">

                            <div className="section-title section-title-center">
                                <h3 className="wow fadeInUp">What we do</h3>
                                <h2 className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">From data to decisions - we build <span>AI that works</span></h2>
                            </div>

                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-3 col-md-6">

                            <div className="what-we-do-item wow fadeInUp">
                                <div className="icon-box">
                                    <img src="/assets/images/icon-what-we-do-1.svg" alt="" />
                                </div>
                                <div className="what-we-do-content">
                                    <h3>AI Automation</h3>
                                    <p>Streamline repetitive tasks and improve efficiency.</p>
                                </div>
                                <div className="what-we-do-list">
                                    <ul>
                                        <li>Boost productivity</li>
                                        <li>Eliminate repetitive task</li>
                                    </ul>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-3 col-md-6">

                            <div className="what-we-do-item wow fadeInUp" data-wow-delay="0.2s">
                                <div className="icon-box">
                                    <img src="/assets/images/icon-what-we-do-2.svg" alt="" />
                                </div>
                                <div className="what-we-do-content">
                                    <h3>Predictive Analytics</h3>
                                    <p>Data-driven decisions with models that forecast.</p>
                                </div>
                                <div className="what-we-do-list">
                                    <ul>
                                        <li>Forecast trends</li>
                                        <li>Data-driven decisions</li>
                                    </ul>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-3 col-md-6">

                            <div className="what-we-do-item wow fadeInUp" data-wow-delay="0.4s">
                                <div className="icon-box">
                                    <img src="/assets/images/icon-what-we-do-3.svg" alt="" />
                                </div>
                                <div className="what-we-do-content">
                                    <h3>Computer Vision</h3>
                                    <p>From image recognition to real-time video analysis.</p>
                                </div>
                                <div className="what-we-do-list">
                                    <ul>
                                        <li>Recognize patterns</li>
                                        <li>Real-time video analysis</li>
                                    </ul>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-3 col-md-6">

                            <div className="what-we-do-item wow fadeInUp" data-wow-delay="0.6s">
                                <div className="icon-box">
                                    <img src="/assets/images/icon-what-we-do-4.svg" alt="" />
                                </div>
                                <div className="what-we-do-content">
                                    <h3>Voice Recognition</h3>
                                    <p>Voice-powered apps that understand, respond.</p>
                                </div>
                                <div className="what-we-do-list">
                                    <ul>
                                        <li>Voice-enabled tools</li>
                                        <li>Convert speech to text</li>
                                    </ul>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-12">

                            <div className="section-footer-text wow fadeInUp" data-wow-delay="0.8s">
                                <p>Turn complex data into intelligent action - <Link to="contact.html">faster, smarter and at scale.</Link></p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        {/*     <div className="our-features">
                <div className="container">
                    <div className="row section-row align-items-center">
                        <div className="col-lg-6">

                            <div className="section-title">
                                <h3 className="wow fadeInUp">Our features</h3>
                                <h2 className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">Innovative features that drive <span>real-world change</span></h2>
                            </div>

                        </div>

                        <div className="col-lg-6">

                            <div className="section-title-content wow fadeInUp" data-wow-delay="0.4s">
                                <p>Our AI solutions are more than just smart - they're built to solve real problems. From predictive insights to automation.</p>
                            </div>

                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">

                            <div className="our-features-box tab-content wow fadeInUp" data-wow-delay="0.6s" id="featurestab">

                                <div className="features-nav">
                                    <ul className="nav nav-tabs" id="mvTab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link btn-default btn-highlighted active" id="first-tab" data-bs-toggle="tab" data-bs-target="#first" type="button" role="tab" aria-selected="true">Natural Language Processing (NLP)</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link btn-default btn-highlighted" id="second-tab" data-bs-toggle="tab" data-bs-target="#second" type="button" role="tab" aria-selected="false">Predictive Analytics</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link btn-default btn-highlighted" id="thirds-tab" data-bs-toggle="tab" data-bs-target="#thirds" type="button" role="tab" aria-selected="false">AI Automation</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link btn-default btn-highlighted" id="fourth-tab" data-bs-toggle="tab" data-bs-target="#fourth" type="button" role="tab" aria-selected="false">Real-Time Insights Dashboard</button>
                                        </li>
                                    </ul>
                                </div>

                                <div className="feature-item tab-pane fade show active" id="first" role="tabpanel">
                                    <div className="row align-items-center">
                                        <div className="col-lg-6">

                                            <div className="feature-item-content">
                                                <h3>Natural Language Processing (NLP)</h3>
                                                <p>Yes, our solutions are built with flexible APIs that make integration easy with your current tech stack - whether it's CRM, ERP, cloud platforms, or custom software.</p>
                                                <ul>
                                                    <li>Text analysis & sentiment detection</li>
                                                    <li>Multilingual chatbots & virtual assistants</li>
                                                    <li>Document classNameification & entity recognition</li>
                                                </ul>
                                                <Link to="contact.html" className="btn-default">learn more</Link>
                                            </div>

                                        </div>

                                        <div className="col-lg-6">

                                            <div className="feature-image">
                                                <figure className="image-anime">
                                                    <img src="/assets/images/feature-1.jpg" alt="" />
                                                </figure>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div className="feature-item tab-pane fade" id="second" role="tabpanel">
                                    <div className="row align-items-center">
                                        <div className="col-lg-6">

                                            <div className="feature-item-content">
                                                <h3>Predictive Analytics</h3>
                                                <p>Yes, our solutions are built with flexible APIs that make integration easy with your current tech stack - whether it's CRM, ERP, cloud platforms, or custom software.</p>
                                                <ul>
                                                    <li>Text Analysis & Sentiment Detection</li>
                                                    <li>Multilingual Chatbots & Virtual Assistants</li>
                                                    <li>Document classNameification & Entity Recognition</li>
                                                </ul>
                                                <Link to="contact.html" className="btn-default">learn more</Link>
                                            </div>

                                        </div>

                                        <div className="col-lg-6">

                                            <div className="feature-image">
                                                <figure className="image-anime">
                                                    <img src="/assets/images/feature-2.jpg" alt="" />
                                                </figure>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div className="feature-item tab-pane fade" id="thirds" role="tabpanel">
                                    <div className="row align-items-center">
                                        <div className="col-lg-6">

                                            <div className="feature-item-content">
                                                <h3>AI Automation</h3>
                                                <p>Yes, our solutions are built with flexible APIs that make integration easy with your current tech stack - whether it's CRM, ERP, cloud platforms, or custom software.</p>
                                                <ul>
                                                    <li>Text Analysis & Sentiment Detection</li>
                                                    <li>Multilingual Chatbots & Virtual Assistants</li>
                                                    <li>Document classNameification & Entity Recognition</li>
                                                </ul>
                                                <Link to="contact.html" className="btn-default">learn more</Link>
                                            </div>

                                        </div>

                                        <div className="col-lg-6">

                                            <div className="feature-image">
                                                <figure className="image-anime">
                                                    <img src="/assets/images/feature-3.jpg" alt="" />
                                                </figure>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div className="feature-item tab-pane fade" id="fourth" role="tabpanel">
                                    <div className="row align-items-center">
                                        <div className="col-lg-6">

                                            <div className="feature-item-content">
                                                <h3>Real-Time Insights Dashboard</h3>
                                                <p>Yes, our solutions are built with flexible APIs that make integration easy with your current tech stack - whether it's CRM, ERP, cloud platforms, or custom software.</p>
                                                <ul>
                                                    <li>Text Analysis & Sentiment Detection</li>
                                                    <li>Multilingual Chatbots & Virtual Assistants</li>
                                                    <li>Document classNameification & Entity Recognition</li>
                                                </ul>
                                                <Link to="contact.html" className="btn-default">learn more</Link>
                                            </div>

                                        </div>

                                        <div className="col-lg-6">

                                            <div className="feature-image">
                                                <figure className="image-anime">
                                                    <img src="/assets/images/feature-4.jpg" alt="" />
                                                </figure>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div> */}

            {/*   <div className="our-pricing">
        <div className="container">
          <div className="row section-row">
            <div className="col-lg-12">

              <div className="section-title section-title-center">
                <h3 className="wow fadeInUp">Pricing plans</h3>
                <h2 className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">Pick the plan that works for  <span>your business</span></h2>
              </div>

            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 col-md-6">

              <div className="pricing-item wow fadeInUp">

                <div className="pricing-header">
                  <h3>Starter Plan</h3>
                  <p>Perfect for individuals and small teams just getting started with AI.</p>
                  <h2>$24.99<sub>/month</sub></h2>
                </div>



                <div className="pricing-body">
                  <h3>What's Included:</h3>
                  <ul>
                    <li>1 AI Model Integration</li>
                    <li>Dedicated Account Manager</li>
                    <li>Up to 10,000 API calls/month</li>
                  </ul>
                </div>

                <div className="pricing-btn">
                  <Link to="contact.html" className="btn-default">get started now</Link>
                </div>

              </div>

            </div>

            <div className="col-lg-4 col-md-6">

              <div className="pricing-item highlighted-box wow fadeInUp" data-wow-delay="0.2s">

                <div className="pricing-header">
                  <h3>Growth Plan</h3>
                  <p>For growing team that need more power, features, and support.</p>
                  <h2>$49.99<sub>/month</sub></h2>
                </div>

                <div className="pricing-body">
                  <h3>What's Included:</h3>
                  <ul>
                    <li>3 AI Models Included</li>
                    <li>Up to 1L+ API calls/month</li>
                    <li>Up to 10,000 API calls/month</li>
                  </ul>
                </div>

                <div className="pricing-btn">
                  <Link to="contact.html" className="btn-default">get started Free</Link>
                </div>

              </div>

            </div>

            <div className="col-lg-4 col-md-6">

              <div className="pricing-item wow fadeInUp" data-wow-delay="0.4s">

                <div className="pricing-header">
                  <h3>Enterprise Plan</h3>
                  <p>Custom-built AI solutions for large teams and enterprises.</p>
                  <h2>$89.99<sub>/month</sub></h2>
                </div>

                <div className="pricing-body">
                  <h3>What's Included:</h3>
                  <ul>
                    <li>Unlimited API Usage</li>
                    <li>Dedicated Account Manager</li>
                    <li>Up to 10,000 API calls/month</li>
                  </ul>
                </div>

                <div className="pricing-btn">
                  <Link to="contact.html" className="btn-default">get started Free</Link>
                </div>

              </div>

            </div>

            <div className="col-lg-12">

              <div className="pricing-benefit-list wow fadeInUp" data-wow-delay="0.6s">
                <ul>
                  <li><img src="/assets/images/icon-pricing-benefit-1.svg" alt="" />Get 30 day free trial</li>
                  <li><img src="/assets/images/icon-pricing-benefit-2.svg" alt="" />No any hidden fee pay</li>
                  <li><img src="/assets/images/icon-pricing-benefit-3.svg" alt="" />You can cancel anytime </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </div> */}

            <div className="cta-box">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">

                            <div className="cta-box-content">

                                <div className="section-title">
                                    <h3 className="wow fadeInUp">Get in touch</h3>
                                    <h2 className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">We're just a message away from <span>smarter solutions</span></h2>
                                </div>

                                <div className="cta-section-shape">
                                    <img src="/assets/images/section-bg-shape-1.png" alt="" />
                                </div>

                                <div className="cta-contact-info wow fadeInUp" data-wow-delay="0.4s">
                                    <p><Link to="mailto:innosutraailimited@gmail.com">innosutraailimited@gmail.com</Link></p>
                                    <h3><Link to="tel:+9136254875">+91 9136254875 </Link></h3>
                                </div>

                            </div>

                        </div>

                        <div className="col-lg-6">

                            <div className="contact-us-form wow fadeInUp" data-wow-delay="0.4s">
                                <form id="contactForm" action="#" method="POST" data-toggle="validator">
                                    <div className="row">
                                        <div className="form-group col-md-6 mb-4">
                                            <label className="form-label">first name*</label>
                                            <input type="text" name="fname" className="form-control" id="fname" placeholder="First Name" required />
                                            <div className="help-block with-errors"></div>
                                        </div>

                                        <div className="form-group col-md-6 mb-4">
                                            <label className="form-label">last name*</label>
                                            <input type="text" name="lname" className="form-control" id="lname" placeholder="Last Name" required />
                                            <div className="help-block with-errors"></div>
                                        </div>

                                        <div className="form-group col-md-6 mb-4">
                                            <label className="form-label">mobile number*</label>
                                            <input type="text" name="phone" className="form-control" id="phone" placeholder="Phone" required />
                                            <div className="help-block with-errors"></div>
                                        </div>

                                        <div className="form-group col-md-6 mb-4">
                                            <label className="form-label">email address*</label>
                                            <input type="email" name="email" className="form-control" id="email" placeholder="Email" required />
                                            <div className="help-block with-errors"></div>
                                        </div>

                                        <div className="form-group col-md-12 mb-5">
                                            <label className="form-label">message</label>
                                            <textarea name="message" className="form-control" id="message" rows="4" placeholder="Enter Message Here..."></textarea>
                                            <div className="help-block with-errors"></div>
                                        </div>

                                        <div className="col-md-12">
                                            <button type="submit" className="btn-default"><span>Submit Message</span></button>
                                            <div id="msgSubmit" className="h3 hidden"></div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="how-it-work">
                <div className="container">
                    <div className="row section-row">
                        <div className="col-lg-12">

                            <div className="section-title section-title-center">
                                <h3 className="wow fadeInUp">How it works</h3>
                                <h2 className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">Our Step-by-step process to <span>AI success</span></h2>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">

                            <div className="work-step-item-list">

                                <div className="work-step-item active wow fadeInUp">

                                    <div className="work-step-no">
                                        <p>Step 01</p>
                                    </div>

                                    <div className="work-step-body">
                                        <div className="icon-box">
                                            <img src="/assets/images/icon-work-step-1.svg" alt="" />
                                        </div>
                                        <div className="work-step-content">
                                            <h3>Discover & Define</h3>
                                            <p>We start by understanding your business and goals.</p>
                                            <ul>
                                                <li>Define key objectives</li>
                                                <li>Identify AI opportunities</li>
                                            </ul>
                                        </div>
                                    </div>

                                </div>

                                <div className="work-step-item wow fadeInUp" data-wow-delay="0.2s">

                                    <div className="work-step-no">
                                        <p>Step 02</p>
                                    </div>

                                    <div className="work-step-body">
                                        <div className="icon-box">
                                            <img src="/assets/images/icon-work-step-2.svg" alt="" />
                                        </div>
                                        <div className="work-step-content">
                                            <h3>Design & Develop</h3>
                                            <p>Our team builds and trains AI models tailored needs.</p>
                                            <ul>
                                                <li>Low-risk MVP</li>
                                                <li>Train and test models</li>
                                            </ul>
                                        </div>
                                    </div>

                                </div>

                                <div className="work-step-item wow fadeInUp" data-wow-delay="0.4s">

                                    <div className="work-step-no">
                                        <p>Step 03</p>
                                    </div>

                                    <div className="work-step-body">
                                        <div className="icon-box">
                                            <img src="/assets/images/icon-work-step-3.svg" alt="" />
                                        </div>
                                        <div className="work-step-content">
                                            <h3>Integrate & Deploy</h3>
                                            <p>We integrate the AI into your systems.</p>
                                            <ul>
                                                <li>Model architecture</li>
                                                <li>Data testing & tuning</li>
                                            </ul>
                                        </div>
                                    </div>

                                </div>

                                <div className="work-step-item wow fadeInUp" data-wow-delay="0.6s">

                                    <div className="work-step-no">
                                        <p>Step 04</p>
                                    </div>

                                    <div className="work-step-body">
                                        <div className="icon-box">
                                            <img src="/assets/images/icon-work-step-4.svg" alt="" />
                                        </div>
                                        <div className="work-step-content">
                                            <h3>Monitor & Optimize</h3>
                                            <p>Post - launch, we monitor the system.</p>
                                            <ul>
                                                <li>Continue updates</li>
                                                <li>Real-time monitoring</li>
                                            </ul>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className="col-lg-12">

                            <div className="section-footer-text wow fadeInUp" data-wow-delay="0.8s">
                                <p><span>Free</span>Let's make something great work together. <Link to="contact.html">Get Free Quote</Link></p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

          {/*   <div className="our-faqs">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">

                            <div className="our-faqs-content">

                                <div className="section-title">
                                    <h3 className="wow fadeInUp">faq's</h3>
                                    <h2 className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">Everything you need to know simplified</h2>
                                    <p className="wow fadeInUp" data-wow-delay="0.4s">Find clear, concise answers to key questions about our AI services, use cases, and how we make AI easy.</p>
                                </div>

                                <div className="faq-cta-box wow fadeInUp" data-wow-delay="0.6s">
                                    <div className="icon-box">
                                        <img src="/assets/images/icon-headset.svg" alt="" />
                                    </div>
                                    <div className="faq-cta-content">
                                        <h3>24*7 Expert Assistance</h3>
                                        <p>We're here for you 24/7, ensuring your AI system runs smoothly.</p>
                                    </div>
                                </div>


                                <div className="faq-button wow fadeInUp" data-wow-delay="0.8s">
                                    <Link to="contact.html" className="btn-default">Contact Us Today</Link>
                                </div>

                            </div>

                        </div>

                        <div className="col-lg-7">

                            <div className="faq-accordion" id="faqaccordion">

                                <div className="accordion-item wow fadeInUp">
                                    <h2 className="accordion-header" id="heading1">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1" aria-expanded="true" aria-controls="collapse1">
                                            1. Can I integrate your AI tools into my existing systems?
                                        </button>
                                    </h2>
                                    <div id="collapse1" className="accordion-collapse collapse show" aria-labelledby="heading1" data-bs-parent="#faqaccordion">
                                        <div className="accordion-body">
                                            <p>Yes, our solutions are built with flexible APIs that make integration easy with your current tech stack - whether it's CRM, ERP, cloud platforms, or custom software.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item wow fadeInUp" data-wow-delay="0.2s">
                                    <h2 className="accordion-header" id="heading2">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                                            2. How long does it take to deploy an AI model?
                                        </button>
                                    </h2>
                                    <div id="collapse2" className="accordion-collapse collapse" aria-labelledby="heading2" data-bs-parent="#faqaccordion">
                                        <div className="accordion-body">
                                            <p>Yes, our solutions are built with flexible APIs that make integration easy with your current tech stack - whether it's CRM, ERP, cloud platforms, or custom software.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item wow fadeInUp" data-wow-delay="0.4s">
                                    <h2 className="accordion-header" id="heading3">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                                            3. Do you offer custom AI model development?
                                        </button>
                                    </h2>
                                    <div id="collapse3" className="accordion-collapse collapse" aria-labelledby="heading3" data-bs-parent="#faqaccordion">
                                        <div className="accordion-body">
                                            <p>Yes, our solutions are built with flexible APIs that make integration easy with your current tech stack - whether it's CRM, ERP, cloud platforms, or custom software.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item wow fadeInUp" data-wow-delay="0.6s">
                                    <h2 className="accordion-header" id="heading4">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                                            4. What kind of support do you offer after deployment?
                                        </button>
                                    </h2>
                                    <div id="collapse4" className="accordion-collapse collapse" aria-labelledby="heading4" data-bs-parent="#faqaccordion">
                                        <div className="accordion-body">
                                            <p>Yes, our solutions are built with flexible APIs that make integration easy with your current tech stack - whether it's CRM, ERP, cloud platforms, or custom software.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item wow fadeInUp" data-wow-delay="0.8s">
                                    <h2 className="accordion-header" id="heading5">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse5" aria-expanded="true" aria-controls="collapse5">
                                            5. Is my data secure with your platform?
                                        </button>
                                    </h2>
                                    <div id="collapse5" className="accordion-collapse collapse" aria-labelledby="heading5" data-bs-parent="#faqaccordion">
                                        <div className="accordion-body">
                                            <p>Yes, our solutions are built with flexible APIs that make integration easy with your current tech stack - whether it's CRM, ERP, cloud platforms, or custom software.</p>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div className="col-lg-12">

                            <div className="company-supports-slider">

                                <div className="company-supports-content wow fadeInUp" data-wow-delay="0.2s">
                                    <hr />
                                    <p>Brands We Work With</p>
                                    <hr />
                                </div>


                                <div className="swiper">
                                    <div className="swiper-wrapper">

                                        <div className="swiper-slide">
                                            <div className="company-supports-logo">
                                                <img src="/assets/images/company-supports-logo-1.svg" alt="" />
                                            </div>
                                        </div>

                                        <div className="swiper-slide">
                                            <div className="company-supports-logo">
                                                <img src="/assets/images/company-supports-logo-2.svg" alt="" />
                                            </div>
                                        </div>

                                        <div className="swiper-slide">
                                            <div className="company-supports-logo">
                                                <img src="/assets/images/company-supports-logo-3.svg" alt="" />
                                            </div>
                                        </div>

                                        <div className="swiper-slide">
                                            <div className="company-supports-logo">
                                                <img src="/assets/images/company-supports-logo-4.svg" alt="" />
                                            </div>
                                        </div>

                                        <div className="swiper-slide">
                                            <div className="company-supports-logo">
                                                <img src="/assets/images/company-supports-logo-5.svg" alt="" />
                                            </div>
                                        </div>

                                        <div className="swiper-slide">
                                            <div className="company-supports-logo">
                                                <img src="/assets/images/company-supports-logo-1.svg" alt="" />
                                            </div>
                                        </div>

                                        <div className="swiper-slide">
                                            <div className="company-supports-logo">
                                                <img src="/assets/images/company-supports-logo-2.svg" alt="" />
                                            </div>
                                        </div>

                                        <div className="swiper-slide">
                                            <div className="company-supports-logo">
                                                <img src="/assets/images/company-supports-logo-3.svg" alt="" />
                                            </div>
                                        </div>

                                        <div className="swiper-slide">
                                            <div className="company-supports-logo">
                                                <img src="/assets/images/company-supports-logo-4.svg" alt="" />
                                            </div>
                                        </div>

                                        <div className="swiper-slide">
                                            <div className="company-supports-logo">
                                                <img src="/assets/images/company-supports-logo-5.svg" alt="" />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div> */}

            <div className="our-testimonials">
                <div className="container">
                    <div className="row section-row align-items-center">
                        <div className="col-lg-6">

                            <div className="section-title">
                                <h3 className="wow fadeInUp">our testimonials</h3>
                                <h2 className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">Hear from the people using our <span>AI every day</span></h2>
                            </div>

                        </div>

                        <div className="col-lg-6">

                            <div className="section-content-btn wow fadeInUp" data-wow-delay="0.4s">

                                <div className="section-title-content">
                                    <p>See how content creators, marketers, and developers are using our AI voice generator to craft compelling, authentic-sounding voiceovers.</p>
                                </div>

                                <div className="section-btn">
                                    <Link to="testimonials.html" className="btn-default">View All Reviews</Link>
                                </div>

                            </div>

                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">

                            <div className="testimonial-slider">
                                <div className="swiper">
                                    <div className="swiper-wrapper" data-cursor-text="Drag">

                                        <div className="swiper-slide">
                                            <div className="testimonial-item">
                                                <div className="testimonial-rating">
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                </div>
                                                <div className="testimonial-content">
                                                    <p>Find clear, concise answers to key about our AI services, use case. Find clear, concise answers to key about our AI services, use case.</p>
                                                </div>
                                                <div className="testimonial-author">
                                                    <div className="author-image">
                                                        <figure className="image-anime">
                                                            <img src="/assets/images/author-1.jpg" alt="" />
                                                        </figure>
                                                    </div>
                                                    <div className="author-content">
                                                        <h3>Courtney Henry</h3>
                                                        <p>Co.Founder, CEO</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="swiper-slide">
                                            <div className="testimonial-item">
                                                <div className="testimonial-rating">
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                </div>
                                                <div className="testimonial-content">
                                                    <p>Find clear, concise answers to key about our AI services, use case. Find clear, concise answers to key about our AI services, use case.</p>
                                                </div>
                                                <div className="testimonial-author">
                                                    <div className="author-image">
                                                        <figure className="image-anime">
                                                            <img src="/assets/images/author-2.jpg" alt="" />
                                                        </figure>
                                                    </div>
                                                    <div className="author-content">
                                                        <h3>Marvin McKinney</h3>
                                                        <p>Biffco Enterprises Ltd.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="swiper-slide">
                                            <div className="testimonial-item">
                                                <div className="testimonial-rating">
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                </div>
                                                <div className="testimonial-content">
                                                    <p>Find clear, concise answers to key about our AI services, use case. Find clear, concise answers to key about our AI services, use case.</p>
                                                </div>
                                                <div className="testimonial-author">
                                                    <div className="author-image">
                                                        <figure className="image-anime">
                                                            <img src="/assets/images/author-3.jpg" alt="" />
                                                        </figure>
                                                    </div>
                                                    <div className="author-content">
                                                        <h3>Cameron Williamson</h3>
                                                        <p>Binford Ltd.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="swiper-slide">
                                            <div className="testimonial-item">
                                                <div className="testimonial-rating">
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                </div>
                                                <div className="testimonial-content">
                                                    <p>Find clear, concise answers to key about our AI services, use case. Find clear, concise answers to key about our AI services, use case.</p>
                                                </div>
                                                <div className="testimonial-author">
                                                    <div className="author-image">
                                                        <figure className="image-anime">
                                                            <img src="/assets/images/author-4.jpg" alt="" />
                                                        </figure>
                                                    </div>
                                                    <div className="author-content">
                                                        <h3>Leslie Alexander</h3>
                                                        <p>Barone LLC.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="testimonial-pagination"></div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="our-blog">
                <div className="container">
                    <div className="row section-row">
                        <div className="col-lg-12">

                            <div className="section-title section-title-center">
                                <h3 className="wow fadeInUp">Latest Blog</h3>
                                <h2 className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">Stay ahead with the latest from <span>our experts</span></h2>
                            </div>

                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-4 col-md-6">

                            <div className="post-item wow fadeInUp">

                                <div className="post-featured-image">
                                    <figure className="image-anime">
                                        <img src="/assets/images/post-1.jpg" alt="" />
                                    </figure>


                                    <div className="post-readmore-btn">
                                        <Link to="blog-single.html"><img src="/assets/images/arrow-white.svg" alt="" /></Link>
                                    </div>

                                </div>


                                <div className="post-item-body">


                                    <div className="post-meta">
                                        <ul>
                                            <li><Link to="#"><i className="fa-regular fa-calendar"></i> 15 July, 2025</Link></li>
                                        </ul>
                                    </div>

                                    <div className="post-item-content">
                                        <h2><Link to="blog-single.html">How AI Is Reshaping the Future of Business Operations</Link></h2>
                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className="col-lg-4 col-md-6">

                            <div className="post-item wow fadeInUp" data-wow-delay="0.2s">

                                <div className="post-featured-image">
                                    <figure className="image-anime">
                                        <img src="/assets/images/post-2.jpg" alt="" />
                                    </figure>


                                    <div className="post-readmore-btn">
                                        <Link to="blog-single.html"><img src="/assets/images/arrow-white.svg" alt="" /></Link>
                                    </div>

                                </div>

                                <div className="post-item-body">

                                    <div className="post-meta">
                                        <ul>
                                            <li><Link to="#"><i className="fa-regular fa-calendar"></i> 12 July, 2025</Link></li>
                                        </ul>
                                    </div>

                                    <div className="post-item-content">
                                        <h2><Link to="blog-single.html">From Data to Decisions The Power of Predictive Analytics</Link></h2>
                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className="col-lg-4 col-md-6">

                            <div className="post-item wow fadeInUp" data-wow-delay="0.4s">

                                <div className="post-featured-image">
                                    <figure className="image-anime">
                                        <img src="/assets/images/post-3.jpg" alt="" />
                                    </figure>


                                    <div className="post-readmore-btn">
                                        <Link to="blog-single.html"><img src="/assets/images/arrow-white.svg" alt="" /></Link>
                                    </div>

                                </div>

                                <div className="post-item-body">

                                    <div className="post-meta">
                                        <ul>
                                            <li><Link to="#"><i className="fa-regular fa-calendar"></i> 09 July, 2025</Link></li>
                                        </ul>
                                    </div>

                                    <div className="post-item-content">
                                        <h2><Link to="blog-single.html">Building Scalable AI What Startups Need to Know</Link></h2>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <Footer />

        </>
    )
}

export default Home
